import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";

export class IncentivePointTag extends HasProjectMixin(Model) {
  static get $name() {
    return "IncentivePointTag";
  }

  static get fields() {
    return [
      { name: "name", dataSource: "name" },
      { name: "boardId", dataSource: "board" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
    ];
  }
}
